// import { Link } from "react-router-dom";
import { useMenu } from "../context/MenuContext";
import { useLoader } from "../context/LoaderContext";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";
import { scroller } from "react-scroll";

const Navbar = () => {
  const { menuOpen, setMenuOpen } = useMenu();
  const { setLoading } = useLoader();
  const handleMenuClick = () => {
    setMenuOpen(!menuOpen);
  };
  const linkClicker = (path: string) => {
    const pathLocation = window.location.pathname.includes(path);
    if (!pathLocation) {
      setLoading(true);
      window.scrollTo(0, 0);
    } else {
      scroller.scrollTo("toTop", {
        duration: 500,
        smooth: true,
      });
    }
  };
  const { companyDetailsData } = useCompanyDetailsContext();
  // const isContactOrTermsPage =
  //   window.location.pathname.includes("contact") ||
  //   window.location.pathname.includes("termscondition");
  // const isContact = window.location.pathname.includes("contact");
  const isTermsPage =
    window.location.pathname.includes("terms-and-condition") ||
    window.location.pathname.includes("faqs");
  const isBooking = window.location.pathname.includes("booking");
  const logo_white = companyDetailsData[0]?.main_logo?.[0]?.media?.url
    ? `${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.main_logo?.[0]?.media?.url}`
    : "https://dashboard.scieverinc.com.np/uploads/logo_white3_747fc8e5de.png";
  const blacklogo = companyDetailsData[0]?.secondary_logo?.[0]?.media?.url
    ? `${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.secondary_logo?.[0]?.media?.url}`
    : "https://dashboard.scieverinc.com.np/uploads/logo_white3_747fc8e5de.png";
  return (
    <>
      <body
        data-rsssl="1"
        className="home page-template-default page page-id-662 tg_menu_transparent tg_lightbox_black centeralign2 loftloader-lite-enabled elementor-default elementor-kit-2567 elementor-page elementor-page-662"
      >
        <div id="perspective">
          <div
            id="wrapper"
            className={`${
              !isTermsPage && !isBooking ? "hasbg transparent" : "custom-hasbg"
            }`}
          >
            <div
              className={`${
                !isTermsPage && !isBooking ? "header_style_wrapper" : ""
              }`}
            >
              <div
                className={`top_bar ${
                  !isTermsPage && !isBooking ? "hasbg" : ""
                }`}
              >
                <div
                  id="logo_wrapper"
                  // style={{ marginTop: isContact ? "-60px" : "unset" }}
                >
                  <div id="menu_wrapper">
                    <div id="nav_wrapper">
                      <div className="nav_wrapper_inner">
                        <div
                          id="menu_border_wrapper"
                          style={{ display: "inline-flex" }}
                        >
                          <button
                            id="mobile_nav_icon"
                            onClick={handleMenuClick}
                            style={{
                              cursor: "pointer",
                              background: "transparent",
                              border: "unset",
                            }}
                          >
                            <span className="ti-menu custom-ti-menu"></span>
                          </button>

                          <div className="menu-main-menu-container">
                            <ul id="main_menu" className="nav">
                              <li className="menu-item">
                                <a
                                  href="/our-rooms"
                                  onClick={() => linkClicker("our-rooms")}
                                >
                                  Reservation
                                </a>
                              </li>
                              <li className="menu-item menu-item-has-children arrow">
                                <a href="/">Explore</a>
                                <ul className="sub-menu">
                                  {/* <li className="menu-item">
                                    <a href="/" onClick={()=>linkClicker("")}>Home</a>
                                  </li> */}
                                  <li className="menu-item">
                                    <a
                                      id="our-rooms"
                                      className="menu-item"
                                      href="/our-rooms"
                                      onClick={() => linkClicker("our-rooms")}
                                    >
                                      Our Rooms
                                    </a>
                                  </li>
                                  {/* <li className="menu-item">
                                    <span
                                      className="disabled-link"
                                      onClick={(e) => e.preventDefault()}
                                    >
                                      Special Offers
                                    </span>
                                  </li> */}
                                  {/* <li className="menu-item">
                                    <a href="/aboutus">About Us</a>
                                  </li> */}
                                  <li className="menu-item">
                                    <a
                                      href="/contact"
                                      onClick={() => linkClicker("contact")}
                                    >
                                      Contact
                                    </a>
                                  </li>
                                  {/* <li className="menu-item">
                                    <a href="/">Testimonial</a>
                                  </li>
                                  <li className="menu-item">
                                    <a href="/">Restaurant</a>
                                  </li>
                                  <li className="menu-item">
                                    <a href="/">Blog</a>
                                  </li>
                                  <li className="menu-item">
                                    <a href="/">Explore</a>
                                  </li>
                                  <li className="menu-item">
                                    <a href="/">My Bookings</a>
                                  </li> */}
                                  {/* <li className="menu-item">
                                    <a href="/gallery">Gallery</a>
                                  </li>
                                  <li className="menu-item">
                                    <a href="/termscondition">
                                      Terms and Conditions
                                    </a>
                                  </li> */}
                                </ul>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id="logo_right_button">
                    {/* <div className="header_client_wrapper">
                      <a className="client_login_link" href="/" title="Login">
                        <span className="ti-lock"></span>Login
                      </a>
                    </div> */}

                    <div className="header_call_wrapper">
                      <span className="ti-mobile"></span>
                      <a
                        className="tooltip"
                        href={`tel:${companyDetailsData[0]?.mobile_number}`}
                        title="Call Us"
                      >
                        {companyDetailsData[0]?.mobile_number}
                      </a>
                      <span
                        className="ti-layout-line-solid"
                        style={{
                          display: "inline-block",
                          transform: "rotate(90deg)",
                          marginRight: "unset",
                        }}
                      ></span>
                      <a
                        className="tooltip"
                        href={`tel:${companyDetailsData[0]?.telephone_number}`}
                        title="Call Us"
                      >
                        {companyDetailsData[0]?.telephone_number}
                      </a>
                    </div>
                  </div>

                  <div id="logo_normal" className="logo_container">
                    <div className="logo_align">
                      <a
                        id="custom_logo"
                        className="logo_wrapper hidden"
                        href="/"
                      >
                        <img
                          src={
                            isTermsPage || isBooking ? blacklogo : logo_white
                          }
                          alt="hotel_bayberry"
                          width="103"
                          height="160"
                        />
                      </a>
                    </div>
                  </div>

                  <div id="logo_transparent" className="logo_container">
                    <div className="logo_align">
                      <a
                        id="custom_logo_transparent"
                        className="logo_wrapper default"
                        href="/"
                      >
                        <img
                          src={
                            isTermsPage || isBooking ? blacklogo : logo_white
                          }
                          alt="hotel_bayberry"
                          height="160"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
};

export default Navbar;
